import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UliItemInitialState, UliItemSetUliId } from './uli-item.actions';
import { UliItemActionParams } from '../models/uli-item-overview.model';

export interface UliItemStateModel extends UliItemActionParams {
  loaded: boolean;
}

const initialState: UliItemStateModel = {
  uli: null,
  compartmentId: null,
  type: null,
  loaded: false,
};

@State<UliItemStateModel>({
  name: 'uliItem',
  defaults: initialState,
})
@Injectable()
export class UliItemState {
  @Selector()
  static getState(state: UliItemStateModel): UliItemStateModel {
    return state;
  }

  @Selector()
  static getUliId(state: UliItemStateModel): string {
    return state.uli;
  }

  @Selector()
  static getLoaded(state: UliItemStateModel): boolean {
    return state.loaded;
  }

  @Action(UliItemSetUliId)
  setUli(ctx: StateContext<UliItemStateModel>, { payload }: UliItemSetUliId): void {
    ctx.patchState({ ...payload, loaded: true });
  }

  @Action(UliItemInitialState)
  setInitialState(ctx: StateContext<UliItemStateModel>): void {
    ctx.setState(initialState);
  }
}
